// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangeVersionDialog-module_content__2hdagvqLFEx63YO-hgubyN","buttons":"ChangeVersionDialog-module_buttons__2htYJI7IqPa4Jc6iar0cYw"};